import { styled } from '@ringcentral/juno';

export const SlideImage = styled.div`
  cursor: pointer;
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  height: 100%;
`;
